export default __webpack_public_path__ + "static/customers_columns-ff8515f06d696ec93979b109c68f0fb8.png";